import { render, staticRenderFns } from "./OrganizationApp.vue?vue&type=template&id=5d933dda&"
import script from "./OrganizationApp.vue?vue&type=script&lang=js&"
export * from "./OrganizationApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports